import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankCriteria } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";
import * as formatting from "@/helpers/formatting.helper";
import _ from "underscore";
import moment from "moment";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },

  [mutation.LIST_SET_CRITERIA](state, searchCriteria) {
    stateMerge(state.listing.criteria, searchCriteria);
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_CLEAR_CRITERIA](state) {
    state.listing.criteria = getBlankCriteria();
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, logs) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = logs;
  },

  [mutation.VIEW_NEXT](state, next) {
    stateMerge(state.view.next, next);
  },
  [mutation.VIEW_PREVIOUS](state, previous) {
    stateMerge(state.view.previous, previous);
  },
  [mutation.VIEW_STARTED](state, id) {
    state.view.loading = true;
    state.view.exceptionId = id;
  },
  [mutation.VIEW_FAILED](state) {
    state.view.loading = false;
    state.view.loaded = false;
  },
  [mutation.VIEW_SUCCEEDED](state, log) {
    state.view.loading = false;
    state.view.loaded = true;
    stateMerge(state.view.data, log);
    state.view.breadcrumbs = [];
    state.view.breadcrumbs.push({
      text: "Exception logs",
      path: "/exception-logs"
    });
    state.view.breadcrumbs.push({
      text: `${formatting.longDateTime(log.date)}`
    });
  },

  [mutation.THROW_STARTED](state) {
    state.throw.processing = true;
  },
  [mutation.THROW_SUCCEEDED](state) {
    state.throw.processing = false;
  },

  [mutation.EXPORT_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.STATS_FOR_WEEK_STARTED](state) {
    state.week.loading = true;
  },
  [mutation.STATS_FOR_WEEK_SUCCEEDED](state, stats) {
    state.week.loading = false;
    state.week.loaded = true;
    state.week.data.dates = _(stats.errorsDuringLastWeek).keys();
    state.week.data.labels = _(_(stats.errorsDuringLastWeek).keys()).map(e => moment(e).format("ddd"));
    state.week.data.labels.pop();
    state.week.data.labels.push("Today");
    state.week.data.values = _(stats.errorsDuringLastWeek).values();
  },
  [mutation.STATS_FOR_WEEK_FAILED](state) {
    state.week.loading = false;
    state.week.loaded = false;
  },

  [mutation.STATS_BY_MONTH_STARTED](state) {
    state.month.loading = true;
  },
  [mutation.STATS_BY_MONTH_SUCCEEDED](state, stats) {
    state.month.loading = false;
    state.month.loaded = true;
    state.month.data = stats.countsByMonth;
  },
  [mutation.STATS_BY_MONTH_FAILED](state) {
    state.month.loading = false;
    state.month.loaded = false;
  },

  [mutation.STATS_TOGGLE_ACTIVE](state) {
    state.week.active = !state.week.active;
    state.month.active = !state.month.active;
  },

  [mutation.CONNECTIVITY_STARTED](state) {
    state.connectivity.loading = true;
  },
  [mutation.CONNECTIVITY_SUCCEEDED](state, results) {
    state.connectivity.loading = false;
    state.connectivity.loaded = true;
    state.connectivity.data = results;
  },
  [mutation.CONNECTIVITY_FAILED](state) {
    state.connectivity.loading = false;
  }
};
